import Payment from './Modules/Payment';

Payment.init().then(() => {
    console.info('Drop-in initialized');
});
